/**
 * Bootstrap-Vue modals can leave .modal-backdrop on <body> when the iframe
 * is hidden while a confirm dialog was open. Call on iframe reopen / reset.
 */
export function teardownBootstrapModals(modalId) {
  if (typeof document === "undefined") {
    return;
  }

  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("padding-right");
  document.body.style.removeProperty("overflow");

  document.querySelectorAll(".modal-backdrop").forEach((node) => {
    node.remove();
  });

  if (modalId) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");
      modalEl.classList.remove("show");
    }
  }
}
